import { ApiError } from '@/api/fetcher';
import { ErrorReason } from '@/shared/types/segment';

/**
 * Collapses a thrown error into a bounded reason for `error_reason`. Driven by
 * the status code only; anything unrecognised is `unknown`.
 */
export const toErrorReason = (error: unknown): ErrorReason => {
  const { code, statusCode } = (error ?? {}) as ApiError;

  if (code === 'NETWORK_ERROR' || statusCode === 0) {
    return 'network';
  }
  // `fetch` rejects with a TypeError when it cannot reach the server at all.
  if (error instanceof TypeError) {
    return 'network';
  }
  if (statusCode === undefined) {
    return 'unknown';
  }
  if (statusCode === 401) {
    return 'unauthorized';
  }
  if (statusCode === 403) {
    return 'forbidden';
  }
  if (statusCode === 404) {
    return 'not_found';
  }
  if (statusCode === 408 || statusCode === 504) {
    return 'timeout';
  }
  if (statusCode === 429) {
    return 'rate_limited';
  }
  if (statusCode >= 400 && statusCode < 500) {
    return 'validation';
  }
  if (statusCode >= 500) {
    return 'server';
  }
  return 'unknown';
};
